
import LearningPath from './learning-path'
import Projects from './projects'

function Icon(props) {
  switch (props.name) {
    case 'learning-path': return <LearningPath {...props} />
    case 'projects': return <Projects {...props} />
    default: return null
  }
}

Icon.defaultProps = {
  color: 'white',
  size: 16,
}

export default Icon
